import React from 'react'

import { theme } from '@acorns/web-components'
import { A4_Spinner } from '@acorns/web-components'
import styled from 'styled-components'

import { LOADING_PAGE } from 'utils/testing/testIDs'

const Container = styled.div`
  align-items: center;
  background-color: ${theme.colors.charcoal};
  display: flex;
  height: 100vh;
  justify-content: center;
  left: 0;
  position: absolute;
  width: 100vw;
`

const Loading = (): React.ReactElement => {
  return (
    <Container data-testid={LOADING_PAGE}>
      <A4_Spinner height={50} width={50} color={theme.colors.ivoryLight} />
    </Container>
  )
}

export { Loading }
